import * as Sentry from '@sentry/react';
import ReactGA from "react-ga4";
import React from 'react';
import ReactDOM from 'react-dom/client';
import {isLocalhost} from 'src/utils/other';
import {App} from './App';

const sentryDsn = process.env.PASSGENAU_SENTRY_DSN;
const instanceTag = process.env.PASSGENAU_INSTANCE_TAG;
const gaMeasurementId = process.env.PASSGENAU_GA_MEASUREMENT_ID;

if (sentryDsn && instanceTag) {
  try {
    Sentry.init({
      dsn: sentryDsn,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.captureConsoleIntegration({
          levels: ['error']
        }),
      ],
      environment: instanceTag,
      tracesSampleRate: 1.0,
    });
  } catch (e) {
    console.log('sentry failure', {e});
  }
} else {
  if (!isLocalhost()) console.log(
    'Not starting Sentry - missing Sentry environment vars: ' +
    'PASSGENAU_SENTRY_DSN and/or PASSGENAU_SENTRY_ENVIRONMENT_TAG'
  );
}

if (gaMeasurementId) {
  ReactGA.initialize(gaMeasurementId);
}

const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

const initializeBeforeAppRender = async () => {
  renderApp();
}

initializeBeforeAppRender();

export {useAuthToken} from 'src/hooks/AuthHooks';
export {useComponentForQueryResult} from 'src/hooks/UseComponentForQueryResult';
export {DtxSpacer} from 'src/components/common/DtxSpacer';
export {useWidthForRef} from 'src/hooks/useWidthForRef';
export {isSaasConnected} from "src/utils/saasUtils";
